// This is a placeholder file to satisfy the locale import in DateTime.js
export default {};
